import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import {fetchRestaurantProductOptions, deleteRestaurantProductOptionById} from '../../../api/restaurantApi'
import {withAsync} from '../../../api/helpers'

export default function List({ match }) {
    const { path } = match;
    //const [users, setUsers] = useState(null);
    const [productOptions, setProductOptions] = useState(null);

    
    // useEffect(() => {
    //     userService.getAll().then(x => setUsers(x));
    // }, []);

    async function fetchProductOptions() {
        const {error, response } = await withAsync(fetchRestaurantProductOptions)
        //console.log('Fetch categories response', response, error)
        if (error) {
            console.log('error', error)
            return
        }
        console.log('===>  FETCHCAT RESPONSE', response)
        setProductOptions(response.data)
        // console.log(response, "<===== Category data")
    }

    useEffect( () => {
        fetchProductOptions()
    }, []);

    async function deleteProductOption(id) {
        setProductOptions(productOptions.map(x => {
            if (x.id === id) { x.isDeleting = true; }
            return x;
        }));

        const {error, response } = await withAsync(deleteRestaurantProductOptionById, id)
        if (error) {
            console.log('error', error)
            return
        }
        console.log('THIS RESPONSE OF DELETE', response)
        setProductOptions(productOptions => productOptions.filter(x => x.id !== id));
    }

    return (
        <div>
            <h1>Product Options</h1>
            <Link to={`${path}/add`} className="btn btn-sm btn-success mb-2">Add Product Option</Link> 
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th style={{ width: '40%' }}>Name</th>
                        <th style={{ width: '40%' }}>Price</th>
                        <th style={{ width: '20%' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {productOptions && productOptions.map(option =>
                        <tr key={option.id}>
                            <td>{option.name}</td>
                            <td>€ {option.price}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>
                                <Link to={`${path}/edit/${option.id}`} className="btn btn-sm btn-primary mr-1">Edit</Link>
                                <button onClick={() => deleteProductOption(option.id)} className="btn btn-sm btn-danger btn-delete-user" disabled={option.isDeleting}>
                                    {option.isDeleting 
                                        ? <span className="spinner-border spinner-border-sm"></span>
                                        : <span>Delete</span>
                                    }
                                </button>
                            </td>
                        </tr>
                    )}
                    {!productOptions &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="spinner-border spinner-border-lg align-center"></div>
                            </td>
                        </tr>
                    }
                    {productOptions && !productOptions.length &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <div className="p-2">No products options to display</div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    );
}